import React from 'react';
import PropTypes from 'prop-types';
import { Badge, classNames, Container } from '@pella/sash-framework';
import { isValidArray } from '../../utilities/validations';
import CTA from '../cta';

const AnniversaryBanner = ({ data, className }) => {
	const classes = classNames({
		'anniversary-banner relative flex flex-col justify-center items-start bg-repeat before:content-[""] before:absolute before:inset-0 before:bg-black/80 bg-[length:219px_auto]': true,
		'py-10 md:py-8 xl:py-0 xl:h-[360px]': !data?.thin,
		'anniversary-banner--thin py-5 md:py-6': data?.thin,
		[className]: className,
	});

	const gridClasses = classNames({
		'grid grid-cols-1': true,
		'md:grid-cols-[1fr_auto] xl:grid-cols-[1fr_auto_56px_auto_1fr] md:gap-x-8 xl:gap-x-0': data?.thin,
		'xl:grid-cols-[1fr_617px_74px_auto_1fr]': !data?.thin,
	});

	const badgeColClasses = classNames({
		'col-start-1 row-start-1 xl:col-start-2': true,
		'mb-3 md:mb-2': data?.thin,
		'mb-6 xl:col-span-3': !data?.thin,
	});

	const headingColClasses = classNames({
		'col-start-1 row-start-2 xl:col-start-2': true,
		'md:pr-2/12 xl:pr-0': !data?.thin,
	});

	const ctaColClasses = classNames({
		'col-start-1 row-start-3 xl:mt-0': true,
		'mt-4 md:mt-0 self-end md:row-start-1 md:col-start-2 md:row-span-2 xl:col-start-4': data?.thin,
		'mt-10 md:mt-6 xl:text-center xl:row-start-2 xl:col-start-4 xl:self-center': !data?.thin,
	});

	if (!data) return null;

	return (
		<div
			className={classes}
			data-testid='anniversary-banner'
			style={data.background?.url ? { backgroundImage: `url(${data.background.url + '?format=pjpg&auto=webp&quality=90'})` } : null}
		>
			<Container className='z-2'>
				<div className={gridClasses}>
					{data.badge && (
						<div className={badgeColClasses}>
							<Badge
								color={data.thin ? 'black' : 'primary'}
								dangerouslySetInnerHTML={{ __html: data.badge }}
								className={`!gap-x-1 [&>span:first-child]:!text-sm/none md:[&>span:first-child]:!text-lg/none ${data.thin ? '[&>span:first-child]:text-primary' : ''}`}
								size={data.thin ? 'md' : 'lg'}
							/>
						</div>
					)}

					{data.heading && <div className={headingColClasses}>{!data.thin ? <h2 className='m-0 text-white'>{data.heading}</h2> : <p className='text-subtitle m-0 text-white md:text-xl/tight'>{data.heading}</p>}</div>}

					{isValidArray(data.cta) && (
						<div className={ctaColClasses}>
							<CTA
								data={data.cta[0]}
								size={data.thin ? 'sm' : 'lg'}
								className={data.thin ? 'max-md:justify-start max-md:border-0 max-md:!py-1 max-md:px-0 max-md:underline max-md:decoration-white max-md:decoration-2 max-md:underline-offset-4' : '!w-fit'}
							/>
						</div>
					)}
				</div>
			</Container>
		</div>
	);
};

AnniversaryBanner.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default AnniversaryBanner;
